<template>
  <o-view>
    <o-nav-bar title="Velo jaarkaart" :has-back-button="true" />
    <o-header-image image="images/velo-header.jpg" />
    <o-section :large-padding="true">
      <o-title :level="2">Aanvraag in verwerking</o-title>
      <p>
        Uw aanvraag voor een Velo jaarkaart is in behandeling. De kaart wordt
        naar jou opgestuurd ten laatste X werkdagen na de aanvraag.
      </p>
      <p>
        Let erop dat u de kaart eerst dient te activeren vooraleer u deze kan
        gebruiken. De instructies hiervoor worden samen met de kaart opgestuurd.
      </p>
    </o-section>
  </o-view>
</template>

<script>
import OConfirmationView from '@/components/OConfirmationView.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OTitle from '@/components/base/OTitle.vue'
export default {
  name: 'VeloAboAwaiting',
  components: {
    OTitle,
    OHeaderImage,
    OConfirmationView
  }
}
</script>
